// Extracted verbatim from the v3 monolith (see BIRDSEYE.md module split plan).

import { DATA_ITEM, DATA_FIELD } from './constants.js';
import { toArray, normalizeText, textFromNode, pushUniqueNormalizedFieldValue, buildFieldLookup, normalizeUrl, hashString } from './utils.js';

export var _collectInitialItems = function () {
  var self = this;

  // v4: itemSelector is DATA_ITEM when explicit, .w-dyn-item when inferred (discovery.js).
  toArray(this.list.querySelectorAll(this.itemSelector || DATA_ITEM)).forEach(function (node) {
    self._addItemNode(node);
  });
};

export var _extractItemIdentity = function (node, fields) {
  var explicit =
    node.getAttribute('data-pf-id') ||
    node.getAttribute('data-wf-item-id') ||
    node.getAttribute('id') ||
    '';

  explicit = normalizeText(explicit);
  if (explicit) {
    return 'id:' + explicit;
  }

  var parts = [];
  var link = node.querySelector('a[href]');
  if (link) {
    parts.push('href=' + normalizeUrl(link.getAttribute('href')));
  }

  var image = node.querySelector('img');
  if (image) {
    parts.push('img=' + normalizeText(image.getAttribute('src') || image.getAttribute('data-src') || ''));
  }

  var keys = Object.keys(fields || {}).sort();
  keys.forEach(function (field) {
    var values = fields[field] || [];
    if (!values.length) {
      return;
    }
    parts.push(field + '=' + values.join('|'));
  });

  if (!parts.length) {
    var text = normalizeText(textFromNode(node));
    if (text) {
      parts.push('text=' + text);
    }
  }

  if (!parts.length) {
    return null;
  }

  return 'sig:' + hashString(parts.join('||'));
};

export var _extractFieldsFromItem = function (node) {
  var fields = {};
  var fieldNodes = toArray(node.querySelectorAll(DATA_FIELD));

  if (node.matches(DATA_FIELD)) {
    fieldNodes.unshift(node);
  }

  fieldNodes.forEach(function (fieldNode) {
    var key = normalizeText(fieldNode.getAttribute('data-pf-field'));
    if (!key) {
      return;
    }
    pushUniqueNormalizedFieldValue(fields, key, textFromNode(fieldNode));
  });

  // v4: data-pf-field-<field>="value" attributes directly on the item (or a field node),
  // typically CMS-bound single values. Preferred zero-touch form for single-value fields.
  toArray(node.attributes).forEach(function (attr) {
    var name = attr.name;
    if (name.length > 14 && name.slice(0, 14) === 'data-pf-field-') {
      var attrKey = normalizeText(name.slice(14));
      if (attrKey) {
        pushUniqueNormalizedFieldValue(fields, attrKey, attr.value);
      }
    }
  });

  var mapKeys = Object.keys(this.fieldMap || {});
  var i;
  var key;

  for (i = 0; i < mapKeys.length; i += 1) {
    key = normalizeText(mapKeys[i]);
    if (!key || fields[key]) {
      continue;
    }

    var selector = this.fieldMap[mapKeys[i]];
    if (!selector) {
      continue;
    }

    var mappedNodes = toArray(node.querySelectorAll(selector));
    if (!mappedNodes.length) {
      continue;
    }

    mappedNodes.forEach(function (mappedNode) {
      pushUniqueNormalizedFieldValue(fields, key, textFromNode(mappedNode));
    });
  }

  return fields;
};

export var _addItemNode = function (node) {
  if (!node || !(node instanceof Element)) {
    return null;
  }

  if (node.__pfOwnerUid === this._uid) {
    return null;
  }

  var fields = this._extractFieldsFromItem(node);
  var key = this._extractItemIdentity(node, fields);
  if (key && this.itemKeySet.has(key)) {
    this._debugLog('item:duplicate:skip', {
      key: key,
    });
    return null;
  }

  if (key) {
    this.itemKeySet.add(key);
  }

  this.itemIdSeq += 1;

  var record = {
    id: this.itemIdSeq,
    key: key,
    el: node,
    fields: fields,
    fieldLookup: buildFieldLookup(fields),
    searchCache: {},
  };

  node.__pfRecordId = record.id;
  node.__pfOwnerUid = this._uid;
  this.items.push(record);
  return record;
};

export var _removeItemNode = function (node) {
  if (!node || !(node instanceof Element)) {
    return false;
  }

  var idx = this.items.findIndex(function (item) {
    return item.el === node;
  });

  if (idx === -1) {
    return false;
  }

  var record = this.items[idx];
  this.items.splice(idx, 1);
  if (record.key) {
    this.itemKeySet.delete(record.key);
  }
  delete node.__pfRecordId;
  delete node.__pfOwnerUid;
  return true;
};

export var _collectItemNodes = function (rootNode) {
  if (!rootNode || !(rootNode instanceof Element)) {
    return [];
  }

  var selector = this.itemSelector || DATA_ITEM;
  var nodes = [];
  if (rootNode.matches(selector)) {
    nodes.push(rootNode);
  }

  return nodes.concat(toArray(rootNode.querySelectorAll(selector)));
};

